import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterMatchMode, FilterMetadata, FilterOperator, SelectItem } from 'primeng/api';
import { EntityWithUuid } from '../../../../model/custom/entity-with-uuid';
import { DeviceMeasurement } from '../../../../model/device-measurement';
import { TenantsService } from '../../../../services/tenants.service';
import { DevicesService } from '../../../../services/devices.service';
import { Tenant } from '../../../../model/tenant';
import { MeasurementType } from '../../../../model/measurement-type';

@Component({
  selector: 'app-device-measurements-step',
  templateUrl: './device-measurements-step.component.html',
  styleUrls: ['./device-measurements-step.component.scss']
})
export class DeviceMeasurementsStepComponent implements OnInit {

  @Input() tenant: Tenant;
  @Input() selectionMode: 'single' | 'multiple';
  @Input() deviceSelection: EntityWithUuid | EntityWithUuid[];
  @Input() deviceMeasurementSelection: DeviceMeasurement | DeviceMeasurement[];
  @Input() deviceMeasurementFilters: {[field: string]: FilterMetadata};
  @Output() deviceMeasurementSelectionChange: EventEmitter<DeviceMeasurement | DeviceMeasurement[]>;
  @Output() deviceMeasurementFiltersChange: EventEmitter<{ [field: string]: FilterMetadata }>;

  public measurements: DeviceMeasurement[];
  public measurementTypes: SelectItem[];
  public selectedMeasurementTypeSensors: string[];
  public loadingDeviceMeasurements: boolean;
  public first: number;
  public rows: number;

  constructor(
    private tenantsService: TenantsService,
    private devicesService: DevicesService
  ) {
    this.deviceMeasurementSelectionChange = new EventEmitter<DeviceMeasurement | DeviceMeasurement[]>();
    this.deviceMeasurementFiltersChange = new EventEmitter<{ [ field: string ]: FilterMetadata }>();
    this.selectedMeasurementTypeSensors = [];
    this.loadingDeviceMeasurements = true;
    this.first = 0;
    this.rows = 10;
  }

  ngOnInit(): void {
    this.loadingDeviceMeasurements = true;
    this.selectedMeasurementTypeSensors = this.deviceMeasurementFilters['measurementType.sensor']?.value ?? [];
    this.loadDeviceMeasurements();
    this.loadDeviceMeasurementTypes();
  }

  private loadDeviceMeasurements(): void {
    if (this.selectionMode === 'multiple') {
      const arraySelection = this.deviceSelection as EntityWithUuid[];
      const uuids: string[] = arraySelection.map(value => value.uuid);
      this.devicesService.getDeviceMeasurementsOfDevices(uuids).subscribe(response => {
        this.measurements = response.deviceMeasurements;
        this.loadingDeviceMeasurements = false;
      });

    } else if (this.selectionMode === 'single') {
      const objectSelection = this.deviceSelection as EntityWithUuid;
      this.devicesService.getDeviceMeasurementsOfDevices([objectSelection.uuid]).subscribe(response => {
        this.measurements = response.deviceMeasurements;
        this.loadingDeviceMeasurements = false;
      });

    }
  }

  private loadDeviceMeasurementTypes(): void {
    this.tenantsService.getTenantMeasurementTypes(this.tenant.uuid).subscribe(response => {
      this.measurementTypes = response.measurementTypes
        .sort((a, b) => a.sensor > b.sensor ? 1 : -1)
        .map((measurementType: MeasurementType) => ({ value: measurementType.sensor }));
      if (this.measurementTypes.length === this.selectedMeasurementTypeSensors?.length) {
        this.selectedMeasurementTypeSensors = [];
      }
    });
  }

  public beforeApplyFilters(): void {
    if (this.selectedMeasurementTypeSensors.length > 0) {
      this.deviceMeasurementFilters['measurementType.sensor'] = {
        value: this.selectedMeasurementTypeSensors,
        matchMode: FilterMatchMode.IN,
        operator: FilterOperator.AND
      };
    } else {
      this.deviceMeasurementFilters['measurementType.sensor'] = {
        value: this.measurementTypes.map(item => item.value),
        matchMode: FilterMatchMode.IN,
        operator: FilterOperator.AND
      };
    }
  }

}
